import React from "react";
import { ManageModifierCategoryModalProps } from "src/interfaces/modifier-category-props.interface";
import Modal from "src/components/common/Modal";
import ModifierCategoryForm from "./ModifierCategoryForm";

const ManageModifierCategoryModal = React.memo(({
  modifierCategoryToEdit,
  isModifierCategoryModalOpen,
  handleCloseModifierCategoryModal,
}: ManageModifierCategoryModalProps) => {
  
  const modifierCategoryModalTitle = modifierCategoryToEdit
    ? "Edit Category"
    : "Add Category";

  return (
    <Modal
      isOpen={isModifierCategoryModalOpen}
      onClose={handleCloseModifierCategoryModal}
      title={modifierCategoryModalTitle}
      width="520px"
      maxHeight="90dvh"
    >
      <ModifierCategoryForm
        modifierCategoryToEdit={modifierCategoryToEdit}
        handleCloseModifierCategoryModal={handleCloseModifierCategoryModal}
      />
    </Modal>
  );
});

export default ManageModifierCategoryModal;
